import getHighchartsBundle from "../lazy-bundles/load-highcharts-bundle";

window.initHistogramChart = async function (target, colors, chartData) {
    await getHighchartsBundle();
    const val = $(target).closest(".maturity-chart-container");

    var descriptionData = "";

    const title = chartData.title;
    const ticker = chartData.ticker;

    if (title && !chartData.isEuTicker) {
        var titleName = title;

        titleName = "Bar Chart illustrating the average maturity"; //why??
        descriptionData = titleName;
        if (ticker) {
            var tickerName = ticker;
            if (tickerName !== "" && tickerName !== " " && tickerName !== undefined) {
                tickerName = "  of the " + tickerName + " portfolio.";
                descriptionData = titleName + tickerName;
            }
        }
    }

    var i = $(".maturity_breakdown_chart").index(target);
    var uniqueName = "line_chart" + i;
    const chartContainer = "chart_container" + i;
    $(val).attr("id", uniqueName);

    $(val).find(".maturity_breakdown_chart").attr("id", chartContainer);

    var masDataX = [];
    var masData = [];
    chartData.holdings.forEach(function (holding){
        masDataX.push(holding.Label);
        var value = holding.Weight.replace(',', '.');
        var flo = parseFloat(value);
        if (flo >= 0.0) {
            masData.push(flo);
        }
    });

    if (masDataX.length === 0 || masData.length === 0) return;

    var xAxisTitle = {
        text: chartData.yearsText
    };
    var yAxisFormatterFunction = function () { return this.value + "%"; };
    var toolTipFormatterFunction = function () {
        return '<b>' + this.series.name + '</b><br/>' +
            this.x + ': ' + this.y + '%';
    };

    if (chartData.isEuTicker) {
        Highcharts.setOptions({
            lang: { decimalPoint: chartData.percentDecimalSeparator }
        });

        xAxisTitle.text = chartData.labelText;
        yAxisFormatterFunction = function () { return Highcharts.numberFormat(this.value, 1) + "%"; };
        toolTipFormatterFunction = function () {
            return '<b>' + this.series.name + '</b><br/>' +
                this.x + ': ' + Highcharts.numberFormat(this.y, 1) + '%';
        };
    }

    Highcharts.setOptions({ colors: colors })

    return new Highcharts.Chart({
        chart: {
            renderTo: chartContainer,
            type: 'column',
        },
        title: { text: undefined },
        xAxis: {
            title: xAxisTitle,
            categories: masDataX,
            labels: {
                rotation: -40,
                align: 'right',
                style: {
                    fontSize: '12px',
                    fontFamily: 'Verdana, sans-serif'
                }
            }
        },
        yAxis: {
            min: 0,
            tickPixelInterval: 100,
            title: { text: null },
            labels: {
                formatter: yAxisFormatterFunction
            }
        },
        legend: { enabled: false },
        tooltip: {
            formatter: toolTipFormatterFunction
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            }
        },
        accessibility: {
            description: descriptionData
        },
        series: [{ name: chartData.yearsText, data: masData }],
        credits: { enabled: false }
    });
};